import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { removeLayerFromMap, setActivatedLayers, onLoadDataUsersWebGis, getIconVector } from 'store/actions/mapActions';
import { destroyMeasures } from 'store/actions/measureAction';
import { convertToGeoJSONMeasure } from 'helpers/utils';
import { vectorsMeasure } from 'store/actions/layersAction/measureWebGis';
import { getItemProperties } from './inforToggle';
import Toggle from './toggle';
import * as S from './styled';

export default function ListAccordion({ listDataUsers }) {
	const dispatch = useDispatch();
	const [itensToggle, setItensToggle] = useState([]);
	const [loadingItems, setLoadingItems] = useState({});

	// Atualização da lista de toggles e suas propriedades
	const updatedAlertsList = listDataUsers.map((measure) => {
		const toggleItem = itensToggle.find((item) => item.hash === measure.hash);
		return toggleItem ? { ...measure, isChecked: true } : { ...measure, isChecked: false };
	});

	const newList = listDataUsers.map((d) => {
		const item = updatedAlertsList.find((i) => i.hash === d.hash);
		return item ? { ...d, isChecked: item.isChecked } : d;
	});

	useEffect(() => {
		itensToggle.forEach((onMap) => {
			onMap.infor = getItemProperties(onMap);

			// para evitar conflitos no nome da camada
			const name = onMap.type + onMap.name;

			const dataMap = {
				name,
				label: onMap.name,
				icon: getIconVector({ item: onMap.type }),
				type: onMap.type
			};

			if (itensToggle?.length > 0) {
				dispatch(vectorsMeasure({ dataMap })).then(() => {
					dispatch(
						onLoadDataUsersWebGis({
							data: convertToGeoJSONMeasure(itensToggle),
							dataMap
						})
					).then(() => dispatch(setActivatedLayers()));
				});
			}
		});
	}, [itensToggle]);

	// Remoção da camada ao desmontar o componente
	useEffect(
		() => () => {
			itensToggle.forEach((onMap) => {
				const name = onMap.type + onMap.name;
				removeLayerFromMap(name);
				setTimeout(() => dispatch(setActivatedLayers()), 100);
			});
		},
		[itensToggle, dispatch]
	);

	const handleDeleteItem = (hashis) => {
		setLoadingItems((prev) => ({ ...prev, [hashis]: true }));
		dispatch(destroyMeasures([hashis])).finally(() => {
			setLoadingItems((prev) => ({ ...prev, [hashis]: false }));
		});
	};

	return (
		listDataUsers?.length > 0 &&
		listDataUsers.map((item) => {
			item.infor = getItemProperties(item);
			const data = newList.find((d) => d.hash === item.hash);
			const name = item.type + item.name;

			return (
				<S.containerShowDataListAccordion key={item.hash}>
					<Toggle
						item={item}
						itemToggle={data}
						onToggle={(isChecked) => {
							const updatedItem = { ...item, isChecked };

							if (isChecked) {
								if (!itensToggle.some((i) => i.id === updatedItem.id)) {
									setItensToggle([...itensToggle, updatedItem]);
								}
							} else {
								setItensToggle(itensToggle.filter((i) => i.id !== updatedItem.id));
								removeLayerFromMap(name);
								setTimeout(() => dispatch(setActivatedLayers()), 100);
							}
						}}
						onDelete={() => handleDeleteItem(item.hash)}
						loadingDelete={loadingItems[item.hash]} // Passando o estado de loading específico
					/>
				</S.containerShowDataListAccordion>
			);
		})
	);
}
